export default "__VITE_ASSET__BBlCHcGe__"